import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import RouteReducer from "./reducer";
const Route = combineReducers({
  route: RouteReducer,
  form: formReducer,
});

export default Route;
